import {HotelCategory as HotelCategoryUI} from '@travel-frontend/ui-components';

import {config} from '@/config';

type Props = React.ComponentProps<typeof HotelCategoryUI>;

export const HotelCategory: React.FunctionComponent<Props> = (props) => (
  <HotelCategoryUI
    withTooltip={config.hotelDetails.categoryType === undefined}
    {...props}
  />
);
